"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadingState = void 0;
var Status;
(function (Status) {
    Status["UPLOADING"] = "UPLOADING";
    Status["ERROR"] = "ERROR";
    Status["UPLOAD_ERROR"] = "UPLOAD_ERROR";
    Status["CANCELLED"] = "CANCELLED";
    Status["UPLOADED"] = "UPLOADED";
})(Status || (Status = {}));
var UploadingState = /** @class */ (function () {
    function UploadingState(uuid, totalChunks) {
        this._successfulChunks = 0;
        this._error = null;
        this._status = Status.UPLOADING;
        this._totalChunks = totalChunks;
        this._uuid = uuid;
    }
    Object.defineProperty(UploadingState.prototype, "successfulChunks", {
        get: function () {
            return this._successfulChunks;
        },
        enumerable: false,
        configurable: true
    });
    UploadingState.prototype.incrementSuccessfulChunks = function () {
        this._successfulChunks++;
    };
    Object.defineProperty(UploadingState.prototype, "totalChunks", {
        get: function () {
            return this._totalChunks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UploadingState.prototype, "uuid", {
        get: function () {
            return this._uuid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UploadingState.prototype, "error", {
        get: function () {
            return this._error;
        },
        set: function (value) {
            this._status = Status.ERROR;
            this._error = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UploadingState.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (value) {
            this._status = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UploadingState.prototype, "progress", {
        get: function () {
            return ((100 / this._totalChunks) * this._successfulChunks).toFixed(2);
        },
        enumerable: false,
        configurable: true
    });
    UploadingState.prototype.ERROR = function (value) {
        if (value) {
            this.error = value;
        }
        this.status = Status.ERROR;
        return this;
    };
    UploadingState.prototype.UPLOAD_ERROR = function () {
        this.status = Status.UPLOAD_ERROR;
        return this;
    };
    UploadingState.prototype.UPLOADED = function () {
        this.status = Status.UPLOADED;
        return this;
    };
    UploadingState.prototype.CANCELLED = function () {
        this.status = Status.CANCELLED;
        return this;
    };
    return UploadingState;
}());
exports.UploadingState = UploadingState;
//# sourceMappingURL=UploadingState.js.map